import { render } from "./e-collapse.vue?vue&type=template&id=7267117a"
import script from "./e-collapse.vue?vue&type=script&lang=js"
export * from "./e-collapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__